import { useEffect, useCallback } from 'react';
import { createNonSecureRandomId } from './create-non-secure-random-id';
import { useConstant } from './use-constant';
const trapFocusKeys = [];

/**
 * @deprecated Use the FocusLock component instead
 */
const useTrapFocus = (shallTrap, onFocus) => {
  const key = useConstant(createNonSecureRandomId);
  const trapFocus = useCallback(ev => {
    if (key !== trapFocusKeys[trapFocusKeys.length - 1]) {
      return;
    }
    onFocus(ev);
  }, [key, onFocus]);
  useEffect(() => {
    if (shallTrap) {
      document.body.addEventListener('focus', trapFocus, true);
      trapFocusKeys.push(key);
    }
    return () => {
      document.body.removeEventListener('focus', trapFocus, true);
      const index = trapFocusKeys.indexOf(key);
      if (index > -1) {
        trapFocusKeys.splice(index, 1);
      }
    };
  }, [key, shallTrap, trapFocus]);
};
export default useTrapFocus;